import { useCallback, useState } from 'react';
import { useResponsive } from '@op-bridge/bridge-core';

import { useModal } from './useModal';

export const useTxFailed = () => {
  const [showError, setShowError] = useState(true);
  const modalData = useModal();
  const { isMobile } = useResponsive();

  const handleErrorToggle = useCallback(
    (show?: boolean) => {
      if (!!show) {
        if (!isMobile) {
          // document.body.style.overflow = 'hidden';
        }
        setShowError(show);
      } else {
        setShowError((preState) => !preState);
        document.body.style.overflow = '';
      }
    },
    [isMobile],
  );

  const handleErrorShow = useCallback((show: boolean) => {
    if (show) {
      handleErrorToggle(true);
      modalData.modalDispatch({ type: 'OPEN' });
    } else {
      handleErrorToggle(false);
      modalData.modalDispatch({ type: 'CLOSE' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { showError, handleErrorToggle, handleErrorShow };
};
